module.exports = __webpack_public_path__ + "static/media/logo.605fc4aa.svg";